import LeadRequirementsForm from './LeadRequirements';

export default LeadRequirementsForm;
